
























import Vue from 'vue'
import Component from 'vue-class-component'
import { State } from 'vuex-class'

import { projectVariables } from '../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'

import { WEB_PAGE_INFORMATION_LIST } from '../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-2-customer-website-page-information'

@Component
class FrequentlyAskedQuestionsList extends Vue {
  @State('isMobileDevice') isMobileDevice?: boolean

  webPageInformationList = WEB_PAGE_INFORMATION_LIST

  projectName: string = projectVariables.projectName

  updateText (text: string): string {
    let newText = text.replace(/{{appName}}/g, this.projectName || '')
    return newText
  }


}

export default FrequentlyAskedQuestionsList

